import { Component, Input } from '@angular/core';
import { IOriginalCurrency, IPriceDetail } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { PriceType } from "../price/price.component";

export interface IDisplayPriceWithConversion {
    mainPrice: IPriceDetail;
    originalPrice: IOriginalCurrency;
}

@Component({
    selector: 'price-with-conversion',
    template: `
        <div class="prices">
            <price [value]="mainPrice.value"
                   [currency]="mainPrice.currency"
                   [type]="priceType.big"></price>

            <price *ngIf="originalPrice && originalPrice.currency !== mainPrice.currency"
                   class="original-price"
                   [value]="originalPrice.value"
                   [currency]="originalPrice.currency"
                   [type]="priceType.default"></price>
        </div>
    `,
    styles: [`
        .prices {
            display: flex;
            flex-direction: column;
            margin-bottom: 5px;
            text-align: right;
        }

        .original-price {
            color: #666;
            font-style: italic;
        }
    `]
})
export class PriceWithConversionComponent {

    public priceType: typeof PriceType = PriceType;

    @Input()
    public mainPrice: IPriceDetail;

    @Input()
    public originalPrice: IOriginalCurrency;
}
